import { useState, useContext } from "react";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import { createSupplier, updateSupplier } from "../../../services/suppliers";
import { useMutation, useQueryClient } from "react-query";
import { cleanObject, getRandomIntInclusive } from "../../../helpers";
import { useSelector } from "react-redux";

const useSupplierForm = ({ supplierInfo, isEditMode, closeWidget }) => {
  const { business_phone_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const [supplierDetails, setSupplierDetails] = useState({
    name: supplierInfo?.name || "",
    // backend may return stores as ids or as store objects
    stores:
      supplierInfo?.stores?.map((store) =>
        typeof store === "object" ? store?.id : store,
      ) || [],
    phone_number: supplierInfo?.phone_number || "",
    phone_code: supplierInfo?.phone_code || business_phone_code || "",
    contact_name: supplierInfo?.contact_name || "",
    address: supplierInfo?.address || "",
    email: supplierInfo?.email || "",
    opening_balance: supplierInfo?.opening_balance || "",
    // has_consent_lumi_to_contact: has_consent_to_contact_suppliers || true,
  });
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();

  // create a new supplier
  const { mutate: addSupplier, isLoading: isAddingSupplier } = useMutation(
    (data) => createSupplier(data),
  );
  const handleAddSupplier = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = cleanObject({ ...supplierDetails });
    addSupplier(data, {
      onSuccess: () => {
        queryClient.invalidateQueries(["getSuppliers"]);
        triggerToast("Supplier added successfully", "success");
        closeWidget();
      },

      onSettled: () => setRequestLoaderProgress(100),
    });
  };

  // update supplier properties
  const { mutate: updateSupplierDetails, isLoading: isEditingSupplier } =
    useMutation((data) => updateSupplier(data));
  const handleEditSupplier = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = cleanObject({ ...supplierDetails }, ["opening_balance"]);
    updateSupplierDetails(
      { data, id: supplierInfo?.id },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["getSuppliers"]);
          queryClient.invalidateQueries([
            "getSuppliers",
            `${supplierInfo?.id}`,
          ]);

          triggerToast("Supplier updated successfully", "success");
          closeWidget();
        },

        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  const submitSupplierInfo = () => {
    if (isEditMode) handleEditSupplier();
    else handleAddSupplier();
  };

  return {
    isAddingSupplier,
    isEditingSupplier,
    supplierDetails,
    storeList,
    // has_consent_to_contact_suppliers,
    setSupplierDetails,
    submitSupplierInfo,
  };
};

export default useSupplierForm;
